import { ButtonIcon, Callout, LinkUnbrokenIcon, Tooltip } from 'canoe';
import React, { useRef, useState } from 'react';

import { useMultiNodes, useSelection } from 'craft/hooks';
import { useViewportDom } from 'craft/state/viewport/selectors';

import { MediaLinkForm } from './MediaLinkForm';

export const MediaSourceButton = () => {
  const ref = useRef<HTMLButtonElement>(null);
  const [isToolbarVisible, setToolbarVisible] = useState(false);
  const { viewportWrapperEl } = useViewportDom();

  const { selection } = useSelection();
  const {
    props,
    actions: { setProps },
    type,
    collections,
  } = useMultiNodes(selection.all, (node) => ({
    collections: node?.data.custom.collections,
  }));

  // If our nodes are using collections we don't have a media source popout
  if (collections?.length > 0) {
    return null;
  }

  // eslint-disable-next-line react/prop-types
  const hasValue = !!props.src.value;
  const label = type === 'Image' ? 'Image Link' : 'Media Link';
  const placeholder =
    type === 'Image'
      ? 'https://www.example.com/image.jpg'
      : 'https://www.youtube.com/watch?v=dQw4w9WgXcQ';

  return (
    <>
      {isToolbarVisible && (
        <Callout
          usePortal={false}
          referenceElement={ref.current}
          onClose={() => setToolbarVisible(false)}
          closeKey="Escape"
          placement="bottom-end"
          modifiers={[
            {
              name: 'preventOverflow',
              options: {
                boundary: viewportWrapperEl,
                padding: 8,
              },
            },
          ]}
        >
          {(calloutProps) => (
            <div
              data-craft-ignore-events
              ref={calloutProps.ref}
              style={calloutProps.style}
              {...calloutProps.attributes.popper}
            >
              <MediaLinkForm
                // eslint-disable-next-line react/prop-types
                value={props.src.value}
                onSave={(src) => setProps({ src })}
                onClose={() => setToolbarVisible(false)}
                label={label}
                placeholder={placeholder}
              />
            </div>
          )}
        </Callout>
      )}
      <Tooltip placement="top" offset="xxs" content="Media Source">
        <ButtonIcon
          ref={ref}
          onClick={() => {
            window.requestAnimationFrame(() => setToolbarVisible(!isToolbarVisible));
          }}
          size="small"
          active={hasValue}
          icon={LinkUnbrokenIcon}
          radius="small"
          color="white"
        />
      </Tooltip>
    </>
  );
};
